module.exports = __webpack_public_path__ + "img/step_1.613a8b8e.png";